<template>
  <div class="d-flex flex-column w-100">
    <Navbar />

    <div id="main-content" class="p-3">
      <RouterView />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import Navbar from '@/shared/components/menues/Navbar.vue';
</script>

<style lang="scss">
  @import './assets/sass/main.scss';
  @import '../node_modules/bootstrap/scss/bootstrap.scss';

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    min-height: 100vh;
    display: flex;
  }

  #main-content {
    height: 100%;
    background: rgb(242, 243, 248);
    margin-top: 62px;
  }
</style>
